import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTerminatedSubject = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 188",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .450195,
			width: 40,
			height: 40,
			rx: 4,
			fill: "#EBD1E0"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "person_cancel",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_119_12961",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 10,
				y: 10,
				width: 21,
				height: 20,
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Bounding box",
					x: 10.4004,
					y: 10,
					width: 20,
					height: 20,
					fill: "#D9D9D9"
				})
			}), /* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_119_12961)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "person_cancel_2",
					d: "M24.9001 20.8333L23.7334 19.6667L25.4626 17.9167L23.7334 16.1875L24.9001 15L26.6501 16.75L28.3792 15L29.5667 16.1875L27.8167 17.9167L29.5667 19.6667L28.3792 20.8333L26.6501 19.1042L24.9001 20.8333ZM17.9001 20C16.9834 20 16.1987 19.6736 15.5459 19.0208C14.8931 18.3681 14.5667 17.5833 14.5667 16.6667C14.5667 15.75 14.8931 14.9653 15.5459 14.3125C16.1987 13.6597 16.9834 13.3333 17.9001 13.3333C18.8167 13.3333 19.6015 13.6597 20.2542 14.3125C20.907 14.9653 21.2334 15.75 21.2334 16.6667C21.2334 17.5833 20.907 18.3681 20.2542 19.0208C19.6015 19.6736 18.8167 20 17.9001 20ZM11.2334 26.6667V24.3333C11.2334 23.8611 11.3549 23.4271 11.598 23.0313C11.841 22.6354 12.164 22.3333 12.5667 22.125C13.4278 21.6945 14.3028 21.3715 15.1917 21.1563C16.0806 20.941 16.9834 20.8333 17.9001 20.8333C18.8167 20.8333 19.7195 20.941 20.6084 21.1563C21.4973 21.3715 22.3723 21.6945 23.2334 22.125C23.6362 22.3333 23.9591 22.6354 24.2021 23.0313C24.4452 23.4271 24.5667 23.8611 24.5667 24.3333V26.6667H11.2334Z",
					fill: "#73134A"
				})
			})]
		})]
	})
});
export default SvgTerminatedSubject;
